module.exports = __webpack_public_path__ + "static/img/Aaclogo4.10d2db3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aaclogo4.png
// module id = pYLo
// module chunks = 1